import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './App.css';
import CaptchaGoogleV3 from './CaptchaGoogleV3';


const Contact = () => {
    const [data, setData] = useState({ termsAndCondition: false })
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState()
    let cToken = "";
    const [captchaToken, setCaptchaToken] = useState()
    const [showTicketNumber, setShowTicketNumber] = useState(false)
    const location = useLocation();

    useEffect(() => {
        if (location.hash === '#contactUsForm') {
            setShowTicketNumber(true);
            setTimeout(() => {
                const element = document.getElementById('contactUsForm');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        } else {
            setShowTicketNumber(false);
        }
    }, [location]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'termsAndCondition') {
            setData((data) => ({ ...data, [name]: true }));
            return
        }
        setData((data) => ({ ...data, [name]: value }));
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false)
        setError()
        const endPoint = 'https://res.iarc.co.in/api/v1/iarc/webite-contact'
        const res = await fetch(endPoint, {
            method: 'POST', headers: {
                "Content-Type": "application/json",
                Recaptcha: `Recaptcha ${captchaToken}`
            },
            body: JSON.stringify(data)
        });
        const response = await res.json()
        if (response.success) {
            setSuccess(true)
            document.getElementById('contactForm').reset()
        } else {
            setError(response.response)
        }
    }
    const handleVerify = (verifyToken) => {
        !captchaToken && setCaptchaToken(verifyToken);
        cToken = verifyToken;
    };

    return (
        <div className='min-h-screen flex flex-col'>
            <div className='h-20'></div>
            <div className='heading-rounded m-auto text-center text-white font-bold py-4 w-11/12 md:w-3/5'>
                Contact Us
            </div>
            <section className='grow flex items-center'>
                <div className='container px-6 xl:px-0 xl:w-4/5 2xl:container mx-auto py-20'>
                    <div className='grid asset grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full'>

                        <div className='col-span-3 md:col-span-1 h-full flex justify-center'>
                            <div className='contact-box'>
                                <div className='text-2xl font-semibold mb-6'>Registered Office</div>
                                <div className='border-b-2 border-500 w-10/12 mb-8'></div>
                                <div className='flex items-center'>
                                    <img src='/assets/map-pin.svg' />
                                    <p className='points ml-4'>
                                        Plot No. 246, 2nd Floor, Okhla Industrial Estate Phase – III, New Delhi - 110020.
                                    </p>
                                </div>
                                <div className='my-6 flex items-center'>
                                    <img src='/assets/phone.svg' />
                                    <p className='points phone ml-4'>
                                        +91-11-69135410</p>
                                </div>
                                <div className='flex items-center'>
                                    <img src='/assets/mail.svg' />
                                    <p className='points phone ml-4'>
                                        iarc@iarc.co.in</p>
                                </div>
                            </div>
                        </div>
                        {/* <div className='col-span-3 md:col-span-1 h-full flex justify-center'>
                            <div className='contact-box'>
                                <div className='text-2xl font-semibold mb-6'>Registered Office</div>
                                <div className='border-b-2 border-500 w-10/12 mb-8'></div>
                                <div className='flex items-center'>
                                    <img src='/assets/map-pin.svg' />
                                    <p className='points ml-4'>Plot No. 246, 2nd Floor, Okhla Industrial Estate Phase – III,
                                        New Delhi – 110020.</p>
                                </div>
                                <div className='my-6 flex items-center'>
                                    <img src='/assets/phone.svg' />
                                    <p className='points phone ml-4'>
                                        +91-11-40235000</p>
                                </div>
                                <div className='flex items-center'>
                                    <img src='/assets/mail.svg' />
                                    <p className='points phone ml-4'>
                                        iarc@iarc.co.in</p>
                                </div>
                            </div>
                        </div> */}


                        <div className='col-span-3 md:col-span-1 h-full flex justify-center'>
                            <div className='contact-box'>
                                <div className='text-2xl font-semibold mb-6'>Corporate Office</div>
                                <div className='border-b-2 border-500 w-10/12 mb-8'></div>
                                <div className='flex items-center'>
                                    <img src='/assets/map-pin.svg' />
                                    <p className='points ml-4'>
                                        A-601/605, 6th Floor, 215 Atrium, Kanakia Spaces, Near Chakala Metro, Andheri Kurla Road, Andheri (East), Mumbai, Maharashtra 400093.</p>
                                </div>
                                <div className='my-6 flex items-center'>
                                    <img src='/assets/phone.svg' />
                                    <p className='points phone ml-4'>
                                        +91-22-67363000</p>
                                </div>
                                <div className='flex items-center'>
                                    <img src='/assets/mail.svg' />
                                    <p className='points phone ml-4'>

                                        iarc@iarc.co.in

                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-span-3 md:col-span-1 h-full flex justify-center'>
                            <div className='contact-box'>
                                <div className='text-2xl font-semibold mb-6'>Gurgaon Office</div>
                                <div className='border-b-2 border-500 w-10/12 mb-8'></div>
                                <div className='flex items-center'>
                                    <img src='/assets/map-pin.svg' />
                                    <p className='points ml-4'>Plot number 92, 93, 2nd Floor, AIHP Millennium, Phase IV, Udyog Vihar, Sector 18, Shahpur, Gurugram, Haryana - 122015</p>
                                </div>
                                <div className='my-6 flex items-center'>
                                    <img src='/assets/mail.svg' />
                                    <p className='points phone ml-4'>
                                        iarc@iarc.co.in</p>
                                </div>
                            </div>
                        </div>

                        <div className='col-span-3 md:col-span-1 h-full flex justify-center'>
                            <div className='contact-box'>
                                <div className='text-2xl font-semibold mb-6'>Chennai Office</div>
                                <div className='border-b-2 border-500 w-10/12 mb-8'></div>
                                <div className='flex items-center'>
                                    <img src='/assets/map-pin.svg' />
                                    <p className='points ml-4'>
                                        Door No. 1, 9th Floor,
                                        Prashanth Real Gold Tower,
                                        D. No. 39, North Usman Road,
                                        T. Nagar, Chennai – 600017.</p>
                                </div>
                                <div className='my-6 flex items-center'>
                                    <img src='/assets/phone.svg' />
                                    <p className='points phone ml-4'>
                                        +91-44-45544039 </p>
                                </div>
                                <div className='flex items-center'>
                                    <img src='/assets/mail.svg' />
                                    <p className='points phone ml-4'>

                                        iarc@iarc.co.in

                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* <div className='col-span-3 md:col-span-1 h-full flex justify-center'>
                            <div className='contact-box'>
                                <div className='text-2xl font-semibold mb-6'>Delhi Branch Office</div>
                                <div className='border-b-2 border-500 w-10/12 mb-8'></div>
                                <div className='flex items-center'>
                                    <img src='/assets/map-pin.svg' />
                                    <p className='points ml-4'>
                                    Plot no. 246, 2nd Floor, Okhla Ph-3, New Delhi-110020.</p>
                                </div>
                                <div className='my-6 flex items-center'>
                                    <img src='/assets/phone.svg' />
                                    <p className='points phone ml-4'>
                                        +91-11-69135410</p>
                                </div>
                                <div className='flex items-center'>
                                    <img src='/assets/mail.svg' />
                                    <p className='points phone ml-4'>
                                        iarc@iarc.co.in</p>
                                </div>
                            </div>
                        </div> */}

                        <div className='col-span-3 md:col-span-1 h-full flex justify-center'>
                            <div className='contact-box'>
                                <div className='text-2xl font-semibold mb-6'>Customer Service</div>
                                <div className='border-b-2 border-500 w-10/12 mb-8'></div>
                                <div className='my-6 flex items-center'>
                                    <img src='/assets/phone.svg' />
                                    <p className='points phone ml-4'>
                                        011-41199400 </p>
                                </div>
                                <div className='flex items-center'>
                                    <img src='/assets/mail.svg' />
                                    <p className='points phone ml-4'>

                                        customersupport@iarc.co.in

                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-span-3 md:col-span-1 h-full flex justify-center'>
                            <div className='contact-box'>
                                <div className='text-2xl font-semibold mb-6'>Need help now? </div>
                                <div className='border-b-2 border-500 w-10/12 mb-8'></div>
                                <div className='flex items-center'>
                                    <img src='/assets/chat-icon.svg' />
                                    <div className='points text-2xl font-semibold ml-4'>Our AI support assistant is available around the clock to assist you.</div>
                                </div>
                                <div className='flex items-center mt-6'>
                                    <img src='/assets/right-arrow.svg' />
                                    <p className='phone ml-4 cursor-pointer font-bold' onClick={() => window.location.href = '/?chatbot=true'}>
                                        Start Chatting.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id='contactUsForm' className='contactUsForm border p-10 bg-[#F9FAFB] mt-10'>
                        <p>Get In Touch With Us</p>
                        <p className='partition border-b border-[#D1D5DB] w-full mt-6 mb-6'></p>
                        <div className='formContainer'>
                            <form onSubmit={handleSubmit} id="contactForm" className="space-y-6">
                                {/* Fields grid */}
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                    <div>
                                        <label htmlFor="name" className="block text-sm text-[#111928] font-normal">
                                            Full Name
                                        </label>
                                        <input
                                            id="name"
                                            type="text"
                                            name="name"
                                            className="mt-2 block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-black"
                                            placeholder="Enter Full Name"
                                            required
                                            onChange={(e) => handleChange(e)}
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="email" className="block text-sm text-[#111928] font-normal">
                                            Email ID
                                        </label>
                                        <input
                                            id="email"
                                            type="email"
                                            name="email"
                                            className="mt-2 block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-black"
                                            placeholder="Enter Email Id"
                                            required
                                            onChange={(e) => handleChange(e)}
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="phone" className="block text-sm text-[#111928] font-normal">
                                            Phone Number
                                        </label>
                                        <input
                                            id="phone"
                                            type="tel"
                                            name="phone"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            className="mt-2 block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-black"
                                            placeholder="Enter Phone Number"
                                            required
                                            onChange={(e) => handleChange(e)}
                                        />
                                    </div>

                                    <div>
                                        <label htmlFor="loanNo" className="block text-sm text-[#111928] font-normal">
                                            Loan Number
                                        </label>
                                        <input
                                            id="loanNo"
                                            type="text"
                                            name="loan_account_number"
                                            inputMode="numeric"
                                            className="mt-2 block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-black"
                                            placeholder="Enter Loan Number"
                                            onChange={(e) => handleChange(e)}
                                        />
                                    </div>

                                    {showTicketNumber && (
                                        <div>
                                            <label htmlFor="ticketNumber" className="block text-sm text-[#111928] font-normal">
                                                Enter Ticket Number
                                            </label>
                                            <input
                                                id="ticketNumber"
                                                type="text"
                                                name="ticket_number"
                                                className="mt-2 block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-black"
                                                placeholder="Enter Ticket Number"
                                                required
                                                onChange={(e) => handleChange(e)}
                                            />
                                        </div>
                                    )}
                                </div>

                                {/* Reason */}
                                <div>
                                    <label htmlFor="comments" className="block text-sm text-[#111928] font-normal">
                                        Reason for reaching out
                                    </label>
                                    <textarea
                                        id="comments"
                                        name="comments"
                                        className="mt-2 block w-full lg:w-1/2 rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-black h-28"
                                        placeholder="Write text here ..."
                                        required
                                        onChange={(e) => handleChange(e)}
                                    />
                                </div>

                                {/* Terms */}
                                <label className="flex items-center gap-2 text-sm font-medium">
                                    <input
                                        id="terms"
                                        type="checkbox"
                                        name="termsAndCondition"
                                        className="h-4 w-4 accent-[#0E9F6E] rounded border-gray-300"
                                        required
                                        onChange={handleChange}
                                    />
                                    <span>
                                        I agree to the Terms and Conditions and Privacy Policy
                                    </span>
                                </label>

                                <p className="text-sm font-normal">
                                    *By clicking submit, I agree to the terms and conditions and privacy policy and I am giving my consent to receive updates through SMS/ email
                                </p>

                                <CaptchaGoogleV3 handleVerify={handleVerify} />

                                {/* Submit */}
                                <input
                                    type="submit"
                                    value="Submit"
                                    className="mt-2 inline-flex w-full md:w-auto justify-center rounded-lg bg-[#2EB233] px-5 py-2.5 text-white cursor-pointer"
                                />
                            </form>
                        </div>
                        {success && (
                            <p className='text-[#2EB233] mt-6 text-center'>You have Successfully submitted your details</p>
                        )}
                        {error && (
                            <p className='text-[red] mt-6 text-center'>{error}</p>
                        )}
                    </div>
                </div>
            </section>
        </div>
    )
}
export default Contact